import {
    ORDERS_ADD_LIST,
    ORDERS_DETAILS_INVALIDATE,
    ORDERS_DETAILS_REQUEST,
    ORDERS_DETAILS_RECEIVE,
    ORDERS_DETAILS_NA_ERROR,
    ORDERS_DETAILS_ERROR,

    ORDERS_SET_FAVORITE_REQUEST,
    ORDERS_SET_FAVORITE_RECEIVE,
    ORDERS_SET_VIEWED_REQUEST,
    ORDERS_SET_VIEWED_RECEIVE,
    ORDERS_SET_STATUS_REQUEST,
    ORDERS_SET_STATUS_RECEIVE,

    ORDERS_SET_RESERVATION_OVER,

    ORDERS_FILES_REQUEST,
    ORDERS_FILES_RECEIVE,
    ORDERS_FILES_UPLOAD_REQUEST,
    ORDERS_FILES_UPLOAD_PROGRESS,
    ORDERS_FILES_UPLOAD_COMPLETE,
    ORDERS_FILES_UPLOAD_RECEIVE,
    ORDERS_FILES_UPLOAD_ERROR,
    ORDERS_FILES_REMOVE_REQUEST,
    ORDERS_FILES_REMOVE_RECEIVE,

    ORDERS_MESSAGES_REQUEST,
    ORDERS_MESSAGES_RECEIVE,
    ORDERS_MESSAGES_SET_READ_REQUEST,
    ORDERS_MESSAGES_SET_READ_RECEIVE,
    ORDERS_MESSAGES_ADD_REQUEST,
    ORDERS_MESSAGES_ADD_RECEIVE,

    ORDERS_MESSAGES_ADD_ATTACH_RECEIVE,

    ORDERS_REPORT_REQUEST,
    ORDERS_REPORT_RECEIVE,

    SET_ORDERS_QAREPORT_REQUEST
} from './actions';
import getRandomIntInclusive from './../../utils/getRandomIntInclusive';

const message = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_MESSAGES_SET_READ_REQUEST:
            return Object.assign({}, state, {
                isFetchingRead: true
            });
        case ORDERS_MESSAGES_SET_READ_RECEIVE:
            return Object.assign({}, state, action.message, {
                isFetchingRead: false
            });
        default:
            return state;
    }
};

const messages = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_DETAILS_INVALIDATE:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case ORDERS_MESSAGES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ORDERS_MESSAGES_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.messages
            });
        case ORDERS_MESSAGES_SET_READ_REQUEST:
        case ORDERS_MESSAGES_SET_READ_RECEIVE:
            return Object.assign({}, state, {
                items: Object.assign({}, state.items, {
                    [action.messageId]: message(state.items[action.messageId], action)
                })
            });
        case ORDERS_MESSAGES_ADD_REQUEST:
            return Object.assign({}, state, {
                isFetchingAdd: true
            });
        case ORDERS_MESSAGES_ADD_RECEIVE:
            return Object.assign({}, state, {
                isFetchingAdd: false,
                items: Object.assign({}, state.items, {
                    [action.message._id]: action.message
                })
            });
        case ORDERS_MESSAGES_ADD_ATTACH_RECEIVE:
            const newItems = Object.assign({}, state.items);
            delete newItems[action.fileId];
            return Object.assign({}, state, {
                isFetchingAdd: false,
                items: newItems
            });
        default:
            return state;
    }
};

const file = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_FILES_UPLOAD_REQUEST:
            return {
                _id: action.fileId,
                name: action.fileName,
                group: action.group,
                progress: 0,
                location: action.fileName,
                isFetching: true,
                isUploading: true,
                abort: action.abort
            };
        case ORDERS_FILES_UPLOAD_PROGRESS:
            return Object.assign({}, state, {
                progress: action.progress,
                isUploading: true,
                isFetching: true
            });
        case ORDERS_FILES_UPLOAD_COMPLETE:
            return Object.assign({}, state, {
                progress: 100,
                isUploading: false,
                isFetching: true,
            });
        case ORDERS_FILES_REMOVE_REQUEST:
            return Object.assign({}, state, {
                isFetchingRemove: true
            });
        case ORDERS_FILES_UPLOAD_ERROR:
            return Object.assign({}, state, {
                error: true
            });
        default:
            return state;
    }
};


const files = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_DETAILS_INVALIDATE:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case ORDERS_FILES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case ORDERS_FILES_RECEIVE:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.files
            });
        case ORDERS_FILES_UPLOAD_REQUEST:
        case ORDERS_FILES_UPLOAD_PROGRESS:
        case ORDERS_FILES_UPLOAD_COMPLETE:
        case ORDERS_FILES_REMOVE_REQUEST:
        case ORDERS_FILES_UPLOAD_ERROR:
            return Object.assign({}, state, {
                items: Object.assign({}, state.items, {
                    [action.fileId]: file(state.items[action.fileId], action)
                })
            });
        case ORDERS_FILES_UPLOAD_RECEIVE:
            const newItems = Object.assign({}, state.items, {
                [action.data._id]: action.data
            });
            delete newItems[action.fileId];
            return Object.assign({}, state, {
                items: newItems
            });
        case ORDERS_FILES_REMOVE_RECEIVE:
            const newItemsDeleted = Object.assign({}, state.items);
            delete newItemsDeleted[action.fileId];
            return Object.assign({}, state, {
                items: newItemsDeleted
            });
        default:
            return state;
    }
};

const generateViewingCount = () => {
    const zero = getRandomIntInclusive(0, 4);
    if (zero === 0) {
        return 0;
    }
    return getRandomIntInclusive(1, 20);
};

const order = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_DETAILS_INVALIDATE:
            return Object.assign({}, state, {
                didInvalidate: true,
                files: files(state.files, action),
                messages: messages(state.messages, action),
                error: false,
                naError: false,
            });
        case ORDERS_DETAILS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false,
                error: false,
                naError: false,
            });
        case ORDERS_DETAILS_RECEIVE:
            return Object.assign({}, state, action.details, {
                isFetching: false,
                didInvalidate: false,
                viewingCount: generateViewingCount()
            });
        case ORDERS_DETAILS_NA_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                naError: true
            });
        case ORDERS_DETAILS_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                error: true
            });
        case ORDERS_SET_FAVORITE_REQUEST:
            return Object.assign({}, state, {
                isFetchingFavorite: true
            });
        case ORDERS_SET_FAVORITE_RECEIVE:
            return Object.assign({}, state, {
                isFetchingFavorite: false,
                is_favorite: action.value
            });
        case ORDERS_SET_VIEWED_REQUEST:
            return Object.assign({}, state, {
                isFetchingViewed: true
            });
        case ORDERS_SET_VIEWED_RECEIVE:
            return Object.assign({}, state, {
                isFetchingViewed: false,
                is_viewed: true
            });
        case ORDERS_SET_STATUS_REQUEST:
            return Object.assign({}, state, {
                isFetchingStatus: true
            });
        case ORDERS_SET_STATUS_RECEIVE:
            return Object.assign({}, action.details, {
                files: state.files,
                messages: state.messages,
                isFetchingStatus: false
            });
        case ORDERS_SET_RESERVATION_OVER:
            return Object.assign({}, state, {
                isReservationOver: true
            });
        case ORDERS_FILES_REQUEST:
        case ORDERS_FILES_RECEIVE:
        case ORDERS_FILES_UPLOAD_REQUEST:
        case ORDERS_FILES_UPLOAD_PROGRESS:
        case ORDERS_FILES_UPLOAD_COMPLETE:
        case ORDERS_FILES_UPLOAD_RECEIVE:
        case ORDERS_FILES_UPLOAD_ERROR:
        case ORDERS_FILES_REMOVE_REQUEST:
        case ORDERS_FILES_REMOVE_RECEIVE:
            return Object.assign({}, state, {
                files: files(state.files, action)
            });
        case ORDERS_MESSAGES_REQUEST:
        case ORDERS_MESSAGES_RECEIVE:
        case ORDERS_MESSAGES_SET_READ_REQUEST:
        case ORDERS_MESSAGES_SET_READ_RECEIVE:
        case ORDERS_MESSAGES_ADD_REQUEST:
        case ORDERS_MESSAGES_ADD_RECEIVE:
        case ORDERS_MESSAGES_ADD_ATTACH_RECEIVE:
            return Object.assign({}, state, {
                messages: messages(state.messages, action)
            });
        case ORDERS_REPORT_REQUEST:
            return Object.assign({}, state, {
                isFetchingReport: true
            });
        case ORDERS_REPORT_RECEIVE:
            return Object.assign({}, state, {
                isFetchingReport: false,
                isReportSent: true
            });
        case SET_ORDERS_QAREPORT_REQUEST:
            return Object.assign({}, state, {
                isFetchingReport: true
            });
        default:
            return state;
    }
};

const orders = (state = {}, action) => {
    switch (action.type) {
        case ORDERS_ADD_LIST:
            return Object.assign({}, state, action.items);
        case ORDERS_DETAILS_INVALIDATE:
        case ORDERS_DETAILS_REQUEST:
        case ORDERS_DETAILS_RECEIVE:
        case ORDERS_DETAILS_ERROR:
        case ORDERS_DETAILS_NA_ERROR:
        case ORDERS_SET_FAVORITE_REQUEST:
        case ORDERS_SET_FAVORITE_RECEIVE:
        case ORDERS_SET_VIEWED_REQUEST:
        case ORDERS_SET_VIEWED_RECEIVE:
        case ORDERS_SET_STATUS_REQUEST:
        case ORDERS_SET_STATUS_RECEIVE:
        case ORDERS_SET_RESERVATION_OVER:
        case ORDERS_FILES_REQUEST:
        case ORDERS_FILES_RECEIVE:
        case ORDERS_FILES_UPLOAD_REQUEST:
        case ORDERS_FILES_UPLOAD_PROGRESS:
        case ORDERS_FILES_UPLOAD_COMPLETE:
        case ORDERS_FILES_UPLOAD_RECEIVE:
        case ORDERS_FILES_UPLOAD_ERROR:
        case ORDERS_FILES_REMOVE_REQUEST:
        case ORDERS_FILES_REMOVE_RECEIVE:
        case ORDERS_MESSAGES_REQUEST:
        case ORDERS_MESSAGES_RECEIVE:
        case ORDERS_MESSAGES_SET_READ_REQUEST:
        case ORDERS_MESSAGES_SET_READ_RECEIVE:
        case ORDERS_MESSAGES_ADD_REQUEST:
        case ORDERS_MESSAGES_ADD_RECEIVE:
        case ORDERS_MESSAGES_ADD_ATTACH_RECEIVE:
        case ORDERS_REPORT_REQUEST:
        case ORDERS_REPORT_RECEIVE:
        case SET_ORDERS_QAREPORT_REQUEST:
            return Object.assign({}, state, {
                [action.number]: order(state[action.number], action)
            });
        default:
            return state;
    }
};

export default orders;


// WEBPACK FOOTER //
// ./src/store/orders/reducers.js